import LayoutPage from "layouts/LayoutPage";
import background from "assets/replicas/harry-potter/hp-marauders-map/v7/background_global.jpg";
import { newsItems } from "assets/news";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: stretch;

  * {
    color: ${(props) => props.theme.colors.black};
  }

  p {
    text-align: center;
    max-width: 1180px;
    margin: auto;
    padding: 0;
    color: ${(props) => props.theme.colors.black}AA;
    font-size: 15px;
    font-weight: 400;

    ${(props) => props.theme.breakpoints.S} {
      font-size: 14px;
    }
  }
`;

const NewsItemWrapper = styled.div`
  overflow: hidden;

  width: 100%;
  background: ${(props) => props.theme.colors.white}DD;
  backdrop-filter: blur(10px);
  border-radius: 8px;

  display: flex;
  justify-content: center;

  padding: 0 5%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
`;

const NewsItem = styled.div`
  position: relative;
  width: 100%;
  max-width: 800px;

  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 6px;
`;

const NewsItemDate = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;

  margin: 0;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-align: center;
  color: ${(props) => props.theme.colors.black}AA !important;
`;

const News = () => {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const visibleNews = newsItems.filter((item) => {
    if (!item.dateHidden) {
      return true;
    }

    // dateHidden is inclusive. The item becomes hidden starting the following day.
    return startOfToday.getTime() <= item.dateHidden.getTime();
  });

  return (
    <LayoutPage background={background}>
      <Wrapper>
        {visibleNews.map((item, key) => (
          <NewsItemWrapper key={key}>
            <NewsItemDate>
              {item.datePublished.toLocaleDateString("en-US", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </NewsItemDate>

            <NewsItem>{item.page}</NewsItem>
          </NewsItemWrapper>
        ))}
      </Wrapper>
    </LayoutPage>
  );
};

export default News;
